var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21165 16.5103H6.34624C5.72124 16.5103 5.19238 15.9815 5.19238 15.3565V10.1161C5.19238 9.92384 5.3366 9.82764 5.48083 9.82764H8.02893C8.22124 9.82764 8.31738 9.97191 8.31738 10.1161V15.3565C8.36546 16.0296 7.83665 16.5103 7.21165 16.5103ZM5.81741 10.4527V15.3565C5.81741 15.6449 6.05778 15.8854 6.34624 15.8854H7.21165C7.50011 15.8854 7.74048 15.6449 7.74048 15.3565V10.4527H5.81741Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90384 10.4526H1.82689C0.817273 10.4526 0 9.63527 0 8.62566V5.30839C0 4.29878 0.817273 3.48145 1.82689 3.48145H9.90384C10.0961 3.48145 10.1923 3.62566 10.1923 3.7699V10.1642C10.2404 10.3084 10.0961 10.4526 9.90384 10.4526ZM1.82689 4.05835C1.15381 4.05835 0.5769 4.58724 0.5769 5.30839V8.62566C0.5769 9.29873 1.10573 9.8757 1.82689 9.8757H9.56727V4.10647H1.82689V4.05835Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6633 13.818C19.6152 13.818 19.6152 13.818 19.5671 13.818L9.8075 10.4526C9.66326 10.4045 9.61523 10.3084 9.61523 10.1641V3.72182C9.61523 3.57759 9.71134 3.48145 9.8075 3.43337L19.5671 0.0199166C19.6633 -0.0281604 19.7594 0.0199048 19.8556 0.0679818C19.9517 0.116059 19.9998 0.212213 19.9998 0.308367V13.4815C19.9998 13.5776 19.9517 13.6738 19.8556 13.7218C19.8075 13.818 19.7594 13.818 19.6633 13.818ZM10.2402 9.92376L19.3748 13.0488V0.741071L10.2402 3.91414V9.92376Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.6f020f5dc688a9b851edcdbc069c77e3.svg";
export { ForwardRef as ReactComponent };